import { useViewportBelow } from '@ui/hooks/use-viewport-below'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  return useViewportBelow(MOBILE_BREAKPOINT)
}
